import { styled } from "styled-components"

export const StyledPreviewSection = styled.div`
  display: flex;
  flex: 1;
  margin-left: ${({ theme }) => theme.spacing.s};
`
